export const developmentGroup = {
    'meta': {
        'title': 'Grupa Rozwojowo Trerapeutyczna dla Kobiet #cityLocativeIn#',
        'description': 'Podczas spotkań będziemy rozmawiać między innymi o trudnościach, o tym co doskwiera, o troskach, o lękach. O tym co się wydarzyło, a nadal „przygniata” emocjonalnie.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/grupa-rozwojowa-terapeutyczna-dla-kobiet/',
        'title': 'Grupa rozwojowo-terapeutyczna dla kobiet #cityLocativeIn#',
        'name': 'Grupa rozwojowo-terapeutyczna dla kobiet #cityLocativeIn#',
        'heading': 'Grupa rozwojowo-terapeutyczna dla kobiet #cityLocativeIn#',
        'fullName': 'Grupa rozwojowo-terapeutyczna dla kobiet'
    },
    'image': {
        'url': '/images/services/grupa-rozwojowa-terapeutyczna-dla-kobiet.webp',
        'width': 840,
        'height': 321,
        'alt': 'Grupa rozwojowo-terapeutyczna dla kobiet #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/grupa-rozwojowa-terapeutyczna-dla-kobiet.webp',
            'width': 840,
            'height': 321,
            'alt': 'Grupa rozwojowo-terapeutyczna dla kobiet #cityLocativeIn#'
        }
    }
}